import CostsDashboard from '@/components/costos/CostsDashboard'

export default function CostosPage() {
  return <CostsDashboard />
}
